import React from "react";
import Reveal from "@/components/marketing/Reveal";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignCls} ${className}`}>
      {eyebrow && (
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-cyanx mb-3">{eyebrow}</p>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-white">{title}</h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-slate-400">{subtitle}</p>}
    </Reveal>
  );
}
